/**
 * 会话各步骤耗时
 */
import appLogger from "./monitor";
import Helper from "@src/common/helper/core";

const LOCAL_KEY = "LOCAL_STEP_LOG";

class StepsLogger {
  beginTime = 0;
  data = {};  // 用于上报
  debugData = {}; // 用于排查问题，记录所有步骤

  hasLoggedOnce = false;
  hasLoggedTwice = false;

  keys = {
    // 会话
    first_response : "ext",       // 首字返回
    search_keyword : "ext1",      // 搜索关键词
    refer_search : "ext2",        // 参考网页
    reply_finished : "ext3",      // 从回答首字到回答完毕时间
    ask_further : "ext5",         // 从提交问题到你可能感兴趣的问题数据接收时间
  }

  constructor () {
    this.beginTime = +new Date;
  }

  /**
   * 记录各步骤时间点
   * @param {String} key 
   * @param {?Boolean} forceUpdate false:记录会话中首次 true:记录会话中最后一次
   * @param {?String} relateKey 从 relateKey 到当前的时间。默认为从开始计时
   */
  record (key, forceUpdate, relateKey) {
    const beginTime = relateKey ? (this.beginTime + (this.data[relateKey] || 0)) : this.beginTime;
    const fixedKey = this.keys[key];
    const debugKey = fixedKey || key;

    if(forceUpdate){
      if(fixedKey){
        this.data[fixedKey] = (+new Date - beginTime);
      }
      this.debugData[debugKey] = (+new Date - beginTime);
    }
    else {
      if(fixedKey){
        this.data[fixedKey] = this.data[fixedKey] || (+new Date - beginTime);
      }
      this.debugData[debugKey] = this.data[debugKey] || (+new Date - beginTime);
    }
  }

  /**
   * 是否已记录
   * @param {String} key 
   */
  hasRecord (key) {
    const fixedKey = this.keys[key];
    return !!(fixedKey && this.data[fixedKey]);
  }

  /**
   * 消息结束，上报时长
   * @param {String} messageId 
   * @param {Boolean} succ 
   * @returns 
   */
  done = (messageId, succ, logData) => {
    // debug
    console.log(`steps done`, messageId, succ, logData);

    // 只有成功的打点
    if(!succ){
      return;
    } 

    if(this.hasLoggedTwice){
      return;
    }
    if(this.hasLoggedOnce){
      this.hasLoggedTwice = true;

      const params = {
        ...{
          key : "aibot_chat",
          action : "message_all_time",
        },
        ...this.data,
        ...logData,
      };
      appLogger.log(params);
      this.saveData({
        ...params,
        ...this.debugData,
      });
      return;
    }
    this.hasLoggedOnce = true;

    const params = {
      ...{
        key : "aibot_chat",
        action : "message_main_time",
      },
      ...Helper.copyObj(this.data, ["ext", "ext1", "ext2", "ext3", "ext4"]),
      ...logData,
    };
    appLogger.log(params);
    this.saveData({
      ...params,
      ...this.debugData,
    });
  }

  // 本地记录，方便排查
  saveData (params) {
    const data = {};
    const keysReverse = this.getKeysReverse();
    Object.keys(params).forEach(key => {
      data[keysReverse[key] || key] = params[key];
    });

    localStorage.setItem(LOCAL_KEY, JSON.stringify(data));
  }
  getKeysReverse () {
    if(this.keysReverse){
      return this.keysReverse;
    }
    const keysReverse = {};
    Object.keys(this.keys).forEach(key => {
      keysReverse[this.keys[key]] = key;
    });
    this.keysReverse = keysReverse;
    return keysReverse;
  }

  /**
   * 用于插入其他参数
   * @param {Object} data 
   */
  updateData (data) {
    this.data = {
      ...this.data,
      ...data,
    }
  }
}

export default StepsLogger;